<header>
  <mat-toolbar role="banner">
    @if (currentTheme == 'light') {
      <img class="logo" ngSrc="images/icons/header-logo.svg" alt="company logo" height="33" width="110" />
    } @else {
      <img class="logo" ngSrc="images/icons/header-dark-logo.svg" alt="company logo" height="32" width="139" />
    }

    <div class="header-actions">
      <core-drop-button
        [items]="currencyList"
        [template]="currency_template"
        valueKey="id"
        (dropClick)="changeCurrency($event)"
        class="responsive"
        [selectedItems]="selectedCurrency"
      />

      <ng-template #currency_template let-item>
        <div class="currency">
          <span>{{ item?.currencyName }}</span>
          <span>{{ item?.currencySymbol }}</span>
        </div>
      </ng-template>

      <core-button [type]="'button'" button_style="stroked" (click)="toggleTheme()" class="responsive_theme-button">
        <span [class.icon-sun]="currentTheme !== 'light'" [class.icon-moon-01]="currentTheme === 'light'"></span>
      </core-button>

      <core-button [type]="'button'" button_style="basic" class="menu-button" (click)="toggleMenu()">
        <span class="icon-menu-02 icon"></span>
      </core-button>
    </div>
  </mat-toolbar>
</header>
